import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import objectFitImages from 'object-fit-images';

import 'react-image-gallery/styles/css/image-gallery.css';

import Share from '../Share';

export default class WorkHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPlayButton: true,
            showVideo: false,
            slideIndex: 0,
        };
    }

    componentDidMount() {
        objectFitImages();
    }

    getImgArray() {
        if (this.props.slider) {
            const items = this.props.slider.acf.slider;
            let imageArray = [];
            let videoObj = [];
            let images = [];
            if (this.props.slider.acf.has_video) {
                videoObj = {
                    original: this.props.slider.acf.video.video_image.sizes
                        .slider_img,
                    thumbnail: this.props.slider.acf.video.video_image.sizes
                        .slider_thumb,
                    embedUrl: this.props.slider.acf.video.video_link,
                    renderItem: this._renderVideo.bind(this),
                };
            }
            for (let i = 0; i < items.length; i++) {
                //create alternative format
                const size = items[i].sizes;

                //Slider Images Object
                imageArray[i] = {
                    original: size.slider_img,
                    thumbnail: size.slider_thumb,
                    srcSet: `${size.slider_img} 1920w, ${size.slider_img_sm} 720w`,
                    sizes: `(min-width:667px) 1920px, 100vw`,
                };
            }
            images = images.concat(imageArray, videoObj);
            return images;
        }
    }

    renderSlider() {
        if (this.props.slider) {
            if (this.props.slider.acf.slider) {
                return (
                    <div className="work-slider">
                        {this.props.slider.acf.has_shadow && (
                            <div className="image-gallery-shadow" />
                        )}

                        <ImageGallery
                            items={this.getImgArray()}
                            slideInterval={2000}
                            showFullscreenButton={false}
                            useBrowserFullscreen={false}
                            showPlayButton={false}
                            onSlide={this._onSlide.bind(this)}
                            showThumbnails={false}
                        />
                        <header
                            id="work-header"
                            className={
                                this.state.showVideo ||
                                this.state.slideIndex > 0
                                    ? 'fadeOut'
                                    : 'fadeIn'
                            }>
                            {this.getTitle(
                                this.props.slider.title.rendered || false
                            )}
                        </header>
                    </div>
                );
            } else {
                return (
                    <header id="work-header" className="noslider">
                        {this.getTitle(
                            this.props.slider.title.rendered || false
                        )}
                    </header>
                );
            }
        }
    }

    getTitle(subtitle) {
        if (this.props.slider) {
            return (
                <div className="content-container">
                    <div className="inner-header">
                        {this.props.slider.acf.slider === false && (
                            <Share
                                title={this.props.slider.title.rendered || ''}
                            />
                        )}
                        {this.props.slider.pure_taxonomies.types && (
                            <span
                                className="work__category"
                                dangerouslySetInnerHTML={{
                                    __html: this.props.slider.pure_taxonomies
                                        .types[0].name,
                                }}
                            />
                        )}

                        <div className="entry-title">
                            <h1>{this.props.slider.acf.subtitle || ''}</h1>
                        </div>
                    </div>
                </div>
            );
        }
    }

    _onSlide(index) {
        this.setState({
            showVideo: false,
            slideIndex: index,
        });
    }

    _toggleShowVideo() {
        this.setState({
            showVideo: true,
        });
    }

    _renderVideo(item) {
        const s = item.embedUrl;
        const div = document.createElement('div');
        div.innerHTML = s;

        let firstVid = div.getElementsByTagName('iframe')[0];
        let vidSrc = firstVid ? firstVid.src : '';

        vidSrc = `${vidSrc}?autoplay=1&autoplay=1`;
        return (
            <div className="image-gallery-image image-gallery-video">
                {this.state.showVideo ? (
                    <div className="videowrapper">
                        <iframe
                            src={vidSrc}
                            width="640"
                            height="360"
                            frameBorder="0"
                            allowFullScreen
                        />
                    </div>
                ) : (
                    <a onClick={this._toggleShowVideo.bind(this)}>
                        <div className="play-button">Play button</div>
                        <img
                            src={item.original}
                            alt="Friends for Brands video poster"
                        />
                    </a>
                )}
            </div>
        );
    }

    render() {
        return <div>{this.renderSlider()}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Work/WorkHeader.jsx